import { render, staticRenderFns } from "./UploadPicture.vue?vue&type=template&id=01780aaa&"
import script from "./UploadPicture.vue?vue&type=script&lang=js&"
export * from "./UploadPicture.vue?vue&type=script&lang=js&"
import style0 from "./UploadPicture.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports